import ActionTypes from '../constants/ActionTypes';

export function isLatestArticlesLoaded(state) {
  return !!(
    state.latestArticles.status &&
    state.latestArticles.status === ActionTypes.FETCH_LATEST_ARTICLES_SUCCESS
  );
}
export function getLatestArticles(state) {
  return state.latestArticles.list || [];
}
